import Vue from "vue";
import Vuex from "vuex";
import invoice from "./modules/invoice.js";
import account from "./modules/account.js";
import dashboard from "./modules/dashboard.js";
import common from "./modules/common.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    invoice,
    common,
    account,
    dashboard
  },
});